export const FETCH_REPORTS_END = "setReports";
export const REPORT_FINAL_DOWNLOADING = "downloadingFinalReport";
export const REPORT_FINAL_DOWNLOADED = "downloadedFinalReport";
export const REPORT_PREVIEW_DOWNLOADING = "downloadingReportPreview";
export const REPORT_PREVIEW_DOWNLOADED = "downloadedReportPreview";
export const REPORT_SET_CONTACT_INFO = "setReportContactInfo";
export const FETCH_START = "setLoading";
export const FETCH_COMPLIANCE_LIMITS_END = "setComplianceLimits";
export const CALCULATED = 'setCalcData';
export const RESET_STATE = "calcResetState";
// Original Plan Provision
export const FETCH_ORIGINAL_PLAN_END = "fetchOriginalPlanEnd";
export const SET_AVAILABLE_SELECT_OPTIONS = "setAvailableSelectOptions";
export const VALIDATE_PARTICIPANTS_START = "validateParticipantStart";
export const VALIDATE_PARTICIPANTS_END = "validateParticipantEnd";
export const VALIDATE_PARTICIPANTS_FAILURE = "validateParticipantFailure";
export const DELETE_PARTICIPANT = "deleteParticipant";
export const DELETE_PARTICIPANT_FIELD = "deleteParticipantField";
export const DELETE_ALL_PARTICIPANT = "deleteAllParticipant";
export const RESET_PARTICIPANTS = "resetParticipants";
export const SET_PARTICIPANTS_ERRORS_INFO = "setParticipantsErrorsInfo";
export const GO_TO_COMPENSATION_SEGMENTS = "goToCompensationSegments";
export const RESET_ATTRIBUTES = "resetAttributes";
export const SET_ANNUAL_COST_ESTIMATION = "setAnnualCostEstimation";
export const SET_COMPENSATION_SEGMENTS = "setCompensationSegments";
export const SET_INVALID_FORM_STATE = "changeDisableNextButtonState";
export const SHOW_FORM_ERRORS = "showFormErrors";
export const HIDE_FORM_ERRORS = "hideFormErrors";
export const START_LOADING = "startLoading";
export const END_LOADING = "endLoading";
// Steps
export const SET_CURRENT_STEP = "setCurrentStep";
export const SET_COMPLETED_STEPS = "setCompletedSteps";
export const STEPS_SET_LAST_STEP_ID = "stepsSetLastStepId";
export const STEP_SET_COMPLETED = "setCompletedStep";
export const STEP_SET_ALTERNATIVE_DESIGNS_STATE = "setAlternativeDesignsStepState";

export const ALTERNATIVE_DESIGNS_SET = "setAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_UPDATED = "updateAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_INDUSTRY_BENCHMARK_SET = "setIndustryBenchmarkAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_SURVEY_SET = "setSurveyAlternativeDesigns";
export const ALTERNATIVE_DESIGN_ADD_CURRENT = "addCurrentAlternativeDesign";
export const ALTERNATIVE_DESIGN_ADD_ARCHIVED = "addArchivedAlternativeDesign";
export const ALTERNATIVE_DESIGN_DELETE_CURRENT = "deleteCurrentAlternativeDesign";
export const ALTERNATIVE_DESIGN_DELETE_ARCHIVED = "deleteArchivedAlternativeDesign";
export const ALTERNATIVE_DESIGNS_DELETE_ARCHIVED = "deleteArchivedAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_CALCULATED = "calculatedAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_RESET_CALCULATED = "resetCalculatedAlternativeDesigns";

export const ALTERNATIVE_DESIGNS_EDIT = "editAlternativeDesign";
export const ALTERNATIVE_DESIGNS_RESET_EDITABLE = "resetEditableAlternativeDesign";

export const ALTERNATIVE_DESIGNS_HIGHLIGHT_DIFFERENCES_CHANGE = "changeHighlightDifferences";
export const ALTERNATIVE_DESIGNS_SET_LAG_INDICATORS_SELECTED_YEAR = "setLagIndicatorsSelectedYear";

export const ARTICLES_FETCH_END = "fetchArticlesEnd";
export const REPORT_ARTICLES_FETCH_END = "fetchReportArticlesEnd";
export const REPORT_ARTICLE_DESTROYED = "destroyedReportArticle";
export const REPORT_ARTICLE_ADDED = "addedReportArticle";

export const FLASH_MESSAGE_SET_POSITION = "setFlashMessagePosition";
export const FLASH_MESSAGE_RESET_POSITION = "resetFlashMessagePosition";
export const FLASH_MESSAGE_SET_WARNING_MESSAGE = "setWarningFlashMessage";
export const FLASH_MESSAGE_SET_ERROR_MESSAGE = "setErrorFlashMessage";

export const PLAN_DESIGN_FIELDS_CHANGE_STATE = "hideOrShowMinimizedPlanDesignFields";

export const AUTH_LOGGEDIN = "authLoggedIn";
export const AUTH_LOGOUT_SUCCESS = "authLogoutSuccess";
